import { createAction } from '../../../store.model';
import { ActionType } from '../main.action';

export interface ToggleFilterGroup {
    groupId: number;
}

export const toggleFilterGroup = createAction<ActionType, ToggleFilterGroup>(
    ActionType.MI2_MAIN__TOGGLE_FILTER_GROUP,
);
